import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
export default function IllustratedLockedIcon(props) {
  return (
    <SvgIcon viewBox="0 0 54 70" {...props}>
      <g clipPath="url(#clip0_1837_3978)">
        <path
          d="M27.0853 5.39998C31.5306 5.39998 35.7226 7.14664 38.8933 10.3173C42.064 13.488 43.8106 17.6826 43.8106 22.1253V36.0426C43.8106 40.488 42.064 44.68 38.8933 47.8506C35.7226 51.0213 31.528 52.768 27.0853 52.768C22.6426 52.768 18.448 51.0213 15.2773 47.8506C12.1066 44.68 10.36 40.4853 10.36 36.0426V22.1253C10.36 17.68 12.1066 13.488 15.2773 10.3173C18.448 7.14664 22.6426 5.39998 27.0853 5.39998ZM27.0853 0.599976C15.2453 0.599976 5.55731 10.288 5.55731 22.128V36.0453C5.55731 47.8853 15.2453 57.5733 27.0853 57.5733C38.9253 57.5733 48.6133 47.8853 48.6133 36.0453V22.128C48.6106 10.288 38.9253 0.599976 27.0853 0.599976V0.599976Z"
          fill="#818387"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.333313 31.8533V69.3013H53.8373V29.0373L0.333313 31.8533Z"
          fill="#74AA50"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.128 44.3653C32.128 41.5786 29.8693 39.3226 27.0853 39.3226C24.3013 39.3226 22.0427 41.5813 22.0427 44.3653C22.0427 45.9813 22.8053 47.416 23.9867 48.3386L22.0427 59.016H32.1307L30.1867 48.3386C31.368 47.416 32.1307 45.9813 32.1307 44.3653H32.128Z"
          fill="#1B6100"
        />
      </g>
      <defs>
        <clipPath id="clip0_1837_3978">
          <rect
            width="53.504"
            height="68.7013"
            fill="white"
            transform="translate(0.333313 0.599976)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
